import React from 'react';
import useNavigation from 'hooks/navigation';
import { Button, Title } from 'components/commons';
import paperIcon from 'assets/svg/paper.svg';
import documentIcon from 'assets/img/docment.png';
import badgeIcon from 'assets/svg/badge.svg';
import './bizon-successful-submission.styles.scss';

const SuccessfulSubmission: React.FC = (): JSX.Element => {
    const {
        goToAntiFraudCheckout,
    } = useNavigation();

    return (
        <div className="bizon-successful-submission">
            <div className="bizon-successful-submission__content">
                <Title className="bizon-successful-submission__title">enviado com sucesso!</Title>
                <span className="bizon-successful-submission__text">
                    Iremos informar por e-mail e whatsapp quando a etapa de identificação estiver concluída.
                    <br/>
                    <br/>
                    Enquanto isso separe os seguintes documentos para a próxima etapa:
                </span>
                <ul className="bizon-successful-submission__content-list">
                    <li>
                        <img src={paperIcon} />
                        <span>Contrato social</span>
                    </li>
                    <li>
                        <img src={documentIcon} />
                        <span>Extratos bancários <br className="hidden-lg"/> (últimos 3 meses)</span>
                    </li>
                    <li>
                        <img src={badgeIcon} />
                        <span>Documentos de identidade dos demais sócios (caso tenha mais de um sócio)</span>
                    </li>
                </ul>

            </div>
            <div className="bizon-successful-submission__footer">
                <div>
                    <Button
                        type="button"
                        label="voltar à tela inicial"
                        onClick={goToAntiFraudCheckout}
                        />
                </div>
            </div>
        </div>
    );
};

export default SuccessfulSubmission;
